const useTouches = ({ v$, userProfiling }) => {
  const touchForm = () => v$.value.$touch();

  const touchUserForm = () => userProfiling?.value?.touch();

  return { touchForm, touchUserForm };
};

export default useTouches;
